<h1 matDialogTitle>
    {{ 'runtime_edit_modal_title' | translate | translateCut: 0 }}
    <strong class="machine-name">
        {{ context.data.name }}
    </strong>
    {{ 'runtime_edit_modal_title' | translate | translateCut: 1 }}
</h1>

<form [formGroup]="form"
      (submit)="onSubmit()">
    <mat-dialog-content>
        <div *ngIf="licenseInfo$ | async as license"
             class="mat-typography runtime-info">
            <mat-icon>info_outline</mat-icon>
            <span>
                {{ 'runtime_edit_modal_info_available' | translate }}
                <strong>
                    {{ license.available }} / {{ license.total }}
                </strong>
            </span>
        </div>

        <mat-form-field>
            <input [placeholder]="'runtime_edit_modal_form_runtimes' | translate"
                   uiAutofocus
                   uiRestrictInput="^[0-9]+$"
                   matInput
                   formControlName="runtimes"
                   class="form-control" />
            <mat-hint *ngIf="form.get('runtimes')!.hasError('range')"
                      [translateParams]="form.get('runtimes')!.getError('range')"
                      translate
                      class="errorMessage">
                runtime_edit_modal_form_runtimes_range_warning
            </mat-hint>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions *ngLet="{
                            loading: loading$ | async
                        } as state"
                        align="end">
        <button mat-dialog-close
                mat-button
                type="button">
            {{ 'modal_action_close' | translate }}
        </button>
        <button [spinnerButtonLoading]="state.loading"
                [disabled]="state.loading ||
                            form.invalid"
                ui-spinner-button
                mat-flat-button
                type="submit"
                color="primary">
            {{'modal_action_update' | translate}}
        </button>
    </mat-dialog-actions>
</form>
